import script from "./AdminUserManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUserManage.vue?vue&type=script&setup=true&lang=js"

import "./AdminUserManage.vue?vue&type=style&index=0&id=cc4eeb64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc4eeb64"]])

export default __exports__